import Wells from "./containers/WellPopover/Popovers/Wells"
import POPOVER_WELLS from "./popoverConsts"

// SUB PAGES
const POPOVERS = new Map()
POPOVERS.set(POPOVER_WELLS, Wells)

export default POPOVERS
